import React, { FC } from 'react';
import classNames from 'classnames';

import { DatetimeFormatType, FriendlyAdditions, TypeOfDate } from 'app/lib/datetime/types';

import Datetime from 'app/design-system/components/Datetime';
import { useTranslation } from 'app/lang';

import { MatchPeriodLabel } from '../MatchPeriodLabel';

import dictionary from './MatchStartTime.dictionary.json';

import styles from './MatchStartTime.module.scss';

type MatchStartTimeProps = {
  value?: string | Date;
  isPrematch?: boolean;
  isSportWithNewScoreboard?: boolean;
};

export const MatchStartTime: FC<MatchStartTimeProps> = ({
  value,
  isPrematch= false,
}) => {
  const { t } = useTranslation();
  const friendlyFormat = isPrematch ? FriendlyAdditions.DEFAULT : FriendlyAdditions.WITH_TIME;
  const matchStartTimeContent = (
    <>
      <Datetime withoutYear
                value={value}
                friendlyFormat={friendlyFormat}
                typeOfDate={TypeOfDate.HUMAN_DATE}
                format={DatetimeFormatType.FRIENDLY} />
      {isPrematch && (
        <Datetime withoutYear
                  value={value}
                  format={DatetimeFormatType.TIME} />
      )}
    </>
  );

  if (value instanceof Date) {
    return (
      <MatchPeriodLabel title={isPrematch ? '' : t(dictionary.title)}
                        className={classNames({ [styles.prematchPeriodLabel]: isPrematch })}>
        {matchStartTimeContent}
      </MatchPeriodLabel>
    );
  }
  return <>{'––'}</>;
};
